import type { Dispatch, LegacyRef, SetStateAction } from "react";
import { useEffect, useRef, useState } from "react";

type UseOutsideClickReturn = {
  ref: LegacyRef<HTMLDivElement>; // Изменено на LegacyRef
  isActive: boolean;
  setIsActive: Dispatch<SetStateAction<boolean>>;
};

const useOutsideClick = (initialValue: boolean): UseOutsideClickReturn => {
  const [isActive, setIsActive] = useState(initialValue);
  const ref = useRef<HTMLDivElement | null>(null); // Тип ref остается таким

  const handleClick = (e: MouseEvent): void => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [isActive]);

  return { ref, isActive, setIsActive };
};

export default useOutsideClick;
